import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BusinessOrderSimple} from '../models/business-order.models';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BusinessOrderService} from '../services/business-order.service';
import {AlertService} from '../../../../common/alert-service/alert.service';
import {LoadingButtonEvent} from '../../../../common/loading-button/loading-button.component';
import {HttpErrorResponse} from '@angular/common/http';
import {
  BusinessOrderStartErrorFetch
} from '../../../../react/workflow/business-order/start/business-order-start-error-fetches.model';

@Component({
    selector: 'business-order-start-modal',
    templateUrl: './business-order-start-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessOrderStartModalComponent {
  @Input() order: BusinessOrderSimple;
  errors: string[] = [];
  errorFetches: BusinessOrderStartErrorFetch[] = [];

  constructor(private businessOrderService: BusinessOrderService,
              private alertService: AlertService,
              private modal: NgbActiveModal) {
  }

  submit(clb?: LoadingButtonEvent): void {
    this.errors = [];
    this.errorFetches = [];
    this.businessOrderService.start(this.order).subscribe(response => {
      this.alertService.add('success', 'BA erfolgreich gestartet!');
      this.modal.close(response);
    }, (error: HttpErrorResponse) => {
      this.errors = error.error?.errors ?? [];
      this.errorFetches = error.error?.error_fetches ?? [];
      if (clb) {
        clb.callback(false);
      }
    });
  }

  trackByFn(index: number, _item: string): number {
    return index;
  }
}
